import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";


const CustomLabelWithInfoIcon = ({label, info, placeTooltip}) => {


    const tooltip = (
        <Tooltip>{info}</Tooltip>
      );


    return (
        <div className='label-container'>
            <Form.Label className="form-label-custom">{label}</Form.Label>
            <div className='switch-list-table-view-container'>
                <OverlayTrigger placement={placeTooltip || "right"} overlay={tooltip}>
                    <InfoIcon fontSize="small" className='switch-view'></InfoIcon>
                </OverlayTrigger>
            </div>
        </div>
    );
}

export default CustomLabelWithInfoIcon;